var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElTableColumn',_vm._g(_vm._b({attrs:{"width":100,"resizable":false},scopedSlots:_vm._u([{key:"default",fn:function({ row: { paused, id } }){return [_c('BidPauseStatusColumnContent',{attrs:{"id":id,"width":"60","is-hovered":id === _vm.currentHoveredRowId,"initial-paused":paused}})]}}])},'ElTableColumn',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }